import { render, staticRenderFns } from "./SpendHubLogo.vue?vue&type=template&id=23952b58&"
import script from "./SpendHubLogo.vue?vue&type=script&lang=js&"
export * from "./SpendHubLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports